import { BreakpointState } from "@angular/cdk/layout";
import {
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
} from "@angular/core";
import { Subscription } from "rxjs";

import { ClickOnAssetEvent } from "@hermes/aphrodite/carousel";
import { Asset } from "@hermes/api-model-asset";
import { ProductTemplateType } from "@hermes/api-model-product";
import { Context } from "@hermes/app-core";
import {
    ProductPageFacade,
    ProductPageAssetService,
} from "@hermes/states/product-page";

import { AssetMediaType } from "@hermes/utils-generic/constants";
import { BreakpointService } from "@hermes/utils-generic/services/user-interface";

@Component({
    selector: "h-product-list-image",
    templateUrl: "./product-list-image.component.html",
    styleUrls: ["./product-list-image.component.scss"],
})
/**
 * The purpose of this component is to display the image of an item.
 * It contains an <ng-content> tag in order to pass by transclusion the elements specific to its use
 */
export class ProductListImageComponent implements OnInit, OnDestroy {
    @Input()
    public currentVariantSku: string;
    /**
     * templateType is not defined in product items so we set it in the parent component with the interface constants
     */
    @Input()
    public templateType: ProductTemplateType;

    @Input()
    public productTitle: string;

    /**
     * Product slug. use in img url (seo)
     */
    public productSlug: string;

    public isMobile: boolean;

    public carouselAsset: Asset[] = [];

    private subscription: Subscription = new Subscription();

    private inputAssets: Asset[];

    constructor(
        private productPageAssetService: ProductPageAssetService,
        private context: Context,
        private productPageFacade: ProductPageFacade,
        private breakpointService: BreakpointService,
        private changeDetector: ChangeDetectorRef,
    ) {}

    @Input()
    public set assets(value: Asset[]) {
        this.inputAssets = value;
        this.carouselAsset = this.productPageAssetService.transformAssets(
            this.productSlug,
            this.templateType,
            this.inputAssets,
        );
    }

    public ngOnInit(): void {
        this.productSlug = encodeURIComponent(this.productTitle);

        if (this.context.isInBrowserMode()) {
            this.subscription.add(
                this.breakpointService
                    .mediumBreakpointObserver()
                    .subscribe((value: BreakpointState) => {
                        this.isMobile = !value.matches;
                        this.changeDetector.detectChanges();
                    }),
            );
        }
    }

    public handleSlideChange(carouselCurrentIndex: number): void {
        this.productPageAssetService.sendAnalyticsTagForCarouselChangeImage(
            carouselCurrentIndex,
            this.templateType,
            this.inputAssets,
            this.currentVariantSku,
            false,
        );
    }

    /**
     * When zoom status change: send analytics
     */
    public openZoomModal(clickOnAssetEvent: ClickOnAssetEvent): void {
        if (clickOnAssetEvent.assetType === AssetMediaType.Image) {
            this.productPageFacade.toggleZoom({
                zoomStatus: true,
                currentIndex: clickOnAssetEvent.carouselCurrentIndex,
                zoomAssets: this.inputAssets,
                isTopLevelProduct: false,
            });
        }
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
